import { FilledButton } from '@sainsburys-tech/luna-button';
import { Display2 } from '@sainsburys-tech/luna-typography';
import * as React from 'react';
export default {
  FilledButton,
  Display2,
  React
};